export default [
  {
    id: 'publisher.payouts',
    slug: 'publisher-payouts',
    icon: 'fas fa-file-invoice-dollar'
  }
]
